import React from "react";
import { RebalanceRequestContainer } from "../../../../../containers";
const RebalanceRequest = (props) => {
  return <RebalanceRequestContainer {...props} />;
};

export default RebalanceRequest;
